
import * as moment from "moment";
import * as main from "../main";
import * as timeinterval from "../timeinterval";
import * as grid from "../grid";

let LABEL_ETooManyDays = "";
let dateTimeErrorMessageLabel = "";

export function initialize(ETooManyDays: string, dateTimeErrorMessage: string): void {
    LABEL_ETooManyDays = ETooManyDays;
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    main.setHideDivBootstrap("periodSelector", false);
    grid.loadGridOptions("AlarmLogGrid");
    searchButtonClicked();
}

export function searchButtonClicked(): void {
    $("#SearchButtonLoader").show();

    main.setHideDiv("DivLblTooMany", false);
    main.setHideDiv("DivGridMsg", false);
    main.setHideDiv("errorMessage", false);

    var selectedInterval = parseInt($("#TimeIntervalID").data("kendoDropDownList").value());
    var from = timeinterval.getBeginPeriodSelection(selectedInterval, null);
    var to = timeinterval.getEndPeriodSelection(selectedInterval, null);

    if (from != null && to != null) {
        var grid = $("#AlarmLogGrid").data("kendoGrid");
        if (grid != null && grid != undefined) {
            grid.pager.dataSource.page(1);
            grid.dataSource.read();
        }
    }
    else {
        $("#SearchButtonLoader").hide();
        // make a message
        main.setHideDiv("errorMessage", true);

        var lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

export function getAdditionalData(): { groupId: number, timestampFrom: Date, timestampTo: Date } {

    // defaults
    let beginDateTime = moment();
    let toLocal = new Date(beginDateTime.unix() * 1000);
    let fromLocal = new Date(beginDateTime.subtract(1, 'days').unix() * 1000);
    let groupId = null;

    // group
    const cbbGroups = $("#CBB_Group").data("kendoDropDownList");
    if (cbbGroups != null && cbbGroups != undefined) {
        groupId = parseInt(cbbGroups.value()) || null;
    }

    // timeinterval
    var ddl = $("#TimeIntervalID").data("kendoDropDownList");
    if (ddl != null && ddl != undefined) {
        const cbbval = parseInt(ddl.value());
        fromLocal = timeinterval.getBeginPeriodSelection(cbbval, null);
        toLocal = timeinterval.getEndPeriodSelection(cbbval, null);

        const tsDays = (toLocal.getTime() - fromLocal.getTime()) / (1000 * 3600 * 24);

        if (tsDays < 0 || tsDays >= 33) {

            // make a message
            main.setHideDiv("DivLblTooMany", true);

            const lblEmsg = $("#LblTooMany");
            if (lblEmsg != null && lblEmsg != undefined) {
                lblEmsg.text(LABEL_ETooManyDays);
            }

            fromLocal = toLocal = new Date(Date.now());
        }
    }

    return {
        groupId: groupId,
        timestampFrom: fromLocal,
        timestampTo: toLocal,
    };
}
